import * as React from 'react';
import { BasePureComponent } from './BaseComponent';
import * as Dati from '../Dati';


interface ICampoStringaProps extends Dati.IBaseProps {
    Valore?: string;
    Disabilitato?: boolean
}

export class CampoStringa extends BasePureComponent<ICampoStringaProps, {}> {
    private _CSS = "form-control";
    constructor(props: any) {
        super(props);
    }

    public render() {
        this._CSS = this.props.CSS != undefined ? this.props.CSS : this._CSS;
        return <input
            type="text"
            className={this._CSS}
            value={this.props.Valore ?? ""}
            name={this.props.Name}
            id={this.props.Id}
            onChange={this.props.OnChange}
            required={this.props.Richiesto != undefined ? this.props.Richiesto : false}
            onBlur={this.props.OnBlur}
            readOnly={this.props.Scrittura != undefined ? !this.props.Scrittura : false}
            disabled={this.props.Disabilitato != undefined ? this.props.Disabilitato : false} />;
    }
}


// WEBPACK FOOTER //
// ./src/components/CampoStringa.tsx